import { AsYouType } from 'libphonenumber-js/min';

const PHONE_PREFIXES = {
  russian: {
    rule: /^\+?[87]/,
    prefix: '+7',
    startExcluded: null,
    code: 'RU',
  },
  belorussian: {
    rule: /^\+?3((75)|7)?/,
    prefix: '+375',
    startExcluded: /^[75]/,
    code: 'BY',
  },
} as const;

const MAX_RU_NATIONAL_NUMBER_LENGTH = 10;

export default () => {
  const localValue = ref('');
  const formattedValue = ref('');

  const onFormat = (v: string) => {
    // TODO: вернуть, когда все ios исчезнут, ну или когда хотя бы поумнеют работать с https://caniuse.com/js-regexp-lookbehind (сейчас ~75% сафари только)
    // v = v.replace(/(?<!^)\+|[^\d+]+/g, '');
    if (v.startsWith('+')) v = `+${v.replace(/\D/g, '')}`;
    else v = v.replace(/\D/g, '');

    Object.values(PHONE_PREFIXES).forEach(({ rule, prefix, startExcluded }) => {
      if (
        rule.test(v) &&
        (!rule.test(localValue.value) ||
          `+${v.replace(/\D/, '')}`.length >= localValue.value.length)
      ) {
        v = `${prefix}${v.replace(rule, '').replace(startExcluded || '', '')}`;
      }
    });

    const phoneTyper = new AsYouType({ defaultCountry: 'RU' });
    formattedValue.value = phoneTyper.input(v);

    const country = phoneTyper.getCountry();
    const chars = phoneTyper.getNumber()?.nationalNumber;

    if (
      country === 'RU' &&
      chars &&
      chars.length > MAX_RU_NATIONAL_NUMBER_LENGTH
    ) {
      phoneTyper.reset();
      formattedValue.value = phoneTyper.input(
        `+7${chars.slice(0, MAX_RU_NATIONAL_NUMBER_LENGTH)}`,
      );
    }

    localValue.value = phoneTyper.getNumberValue() || '';
  };

  const onInput = (e: Event) => {
    const target = e.target as HTMLInputElement;
    const v = target.value;

    onFormat(v);

    target.value = formattedValue.value;
  };

  const value = computed({
    get: () => localValue.value,
    set: onFormat,
  });

  return reactive({
    value,
    formattedValue,
    inputProps: {
      onInput,
      value: formattedValue,
      autocomplete: 'tel',
      inputmode: 'tel' as const,
      type: 'tel',
      name: 'phone',
    },
  });
};
